export const STATUS_CODE_SUCCESS = 200
export const STATUS_CODE_CREATE_SUCCESS = 201
export const STATUS_CODE_UPDATE_SUCCESS = 200
export const STATUS_BAD_REQUEST = 400
export const STATUS_NOT_FOUND = 404
export const STATUS_CODE_CONFLICT = 409
export const EQUALIZATION_DOUBLE_CHECK_WARNING = 'EQUALIZATION_DOUBLE_CHECK_WARNING'
